import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { LayoutContextProvider } from "./LayoutContext";
import { InvestorLayoutChrome } from "./InvestorLayout";
import { MemberLayoutChrome } from "./MemberLayout";
import { MerchantLayoutChrome } from "./MerchantLayout";
import { AdminLayoutChrome } from "./AdminLayout";
import { EmployerLayoutChrome } from "./EmployerLayout";
import { AffiliateLayoutChrome } from "./AffiliateLayout";
import { useAuth } from "@/contexts/AuthContext";

function InnerLoader() {
  return (
    <div className="flex items-center justify-center py-16">
      <Loader2 className="h-7 w-7 animate-spin text-gold" />
    </div>
  );
}

export function InvestorLayoutRoute() {
  return (
    <LayoutContextProvider>
      <InvestorLayoutChrome>
        <Suspense fallback={<InnerLoader />}>
          <Outlet />
        </Suspense>
      </InvestorLayoutChrome>
    </LayoutContextProvider>
  );
}

export function MemberLayoutRoute() {
  return (
    <LayoutContextProvider>
      <MemberLayoutChrome>
        <Suspense fallback={<InnerLoader />}>
          <Outlet />
        </Suspense>
      </MemberLayoutChrome>
    </LayoutContextProvider>
  );
}

export function MerchantLayoutRoute() {
  return (
    <LayoutContextProvider>
      <MerchantLayoutChrome>
        <Suspense fallback={<InnerLoader />}>
          <Outlet />
        </Suspense>
      </MerchantLayoutChrome>
    </LayoutContextProvider>
  );
}

export function EmployerLayoutRoute() {
  return (
    <LayoutContextProvider>
      <EmployerLayoutChrome>
        <Suspense fallback={<InnerLoader />}>
          <Outlet />
        </Suspense>
      </EmployerLayoutChrome>
    </LayoutContextProvider>
  );
}

// Affiliate pages are role-aware: an existing member/vendor who is also an
// affiliate stays inside their own portal chrome (the Affiliate links just
// appear in their sidebar); a standalone `affiliate` account gets the dedicated
// Affiliate portal with its own dashboard.
export function AffiliatePortalRoute() {
  const { user } = useAuth();
  const Chrome =
    user?.role === "member" ? MemberLayoutChrome :
    user?.role === "vendor" ? MerchantLayoutChrome :
    AffiliateLayoutChrome;
  return (
    <LayoutContextProvider>
      <Chrome>
        <Suspense fallback={<InnerLoader />}>
          <Outlet />
        </Suspense>
      </Chrome>
    </LayoutContextProvider>
  );
}

export function AdminLayoutRoute() {
  return (
    <LayoutContextProvider>
      <AdminLayoutChrome>
        <Suspense fallback={<InnerLoader />}>
          <Outlet />
        </Suspense>
      </AdminLayoutChrome>
    </LayoutContextProvider>
  );
}
